import FormInputField from './FormInputField';

export default FormInputField;
export { FormInputField };
